import { useRef, useState } from 'react';

export interface RowDrag {
    isDragging: (index: number) => boolean;
    dropEdge: (index: number) => 'before' | 'after' | undefined;
    start: (index: number) => void;
    over: (index: number) => void;
    end: () => void;
    drop: (index: number) => void;
    move: (index: number, dir: -1 | 1) => void;
}

export function useRowDrag(
    onReorder: ((from: number, to: number) => void) | undefined,
): RowDrag {
    const fromRef = useRef<number | null>(null);
    const [dragIndex, setDragIndex] = useState<number | null>(null);
    const [overIndex, setOverIndex] = useState<number | null>(null);

    function end(): void {
        fromRef.current = null;
        setDragIndex(null);
        setOverIndex(null);
    }

    return {
        isDragging: (index) => dragIndex === index,
        dropEdge: (index) => {
            if (dragIndex === null || overIndex !== index) return undefined;
            if (dragIndex === index) return undefined;
            return dragIndex < index ? 'after' : 'before';
        },
        start: (index) => {
            fromRef.current = index;
            setDragIndex(index);
        },
        over: setOverIndex,
        end,
        drop: (index) => {
            const from = fromRef.current;
            end();
            if (from !== null && from !== index) onReorder?.(from, index);
        },
        move: (index, dir) => {
            onReorder?.(index, index + dir);
        },
    };
}
